<template>
  <el-select
    filterable
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option v-for="item in optionList" :label="item.label" :value="item.value" :key="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'filter-worker-type',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      optionList: [
        {
          label: '业务外包',
          value: 1,
        },
        {
          label: '岗位外包',
          value: 0,
        },
      ],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },

  created() {
    if (this.required) {
      this.selectedValue = this.optionList[0].value
    }
  },
}
</script>
